import React from 'react';
import styled from 'styled-components/macro';
import { serviceDescription, ConsentAndAuthorization } from './terms.data';

const Section = styled.section`
  margin: 3em 0;
`;

const Heading = styled.h4`
  margin-bottom: 1.5em;
`;

const Paragraph = styled.p`
  margin: 1em 0;
`;

const NumberedList = styled.ol`
  padding-left: 1em;
  list-style: auto;
`;

const NumberedListItem = styled.li`
  margin: 1.5em 0;
`;

const BulletList = styled.ul`
  margin-bottom: 2em;
  padding-left: 1.5em;
  list-style: disc;
`;

const BulletListItem = styled.li`
  margin: 0.5em 0;
`;

const TermsDetails = () => (
  <div>
    <Section>
      <Heading>Service Description</Heading>

      {serviceDescription.map((paragraph) => (
        <Paragraph>{paragraph}</Paragraph>
      ))}
    </Section>

    <Section>
      <Heading>Consent and Authorization</Heading>

      <NumberedList>
        {ConsentAndAuthorization.map(({ description, list }) => (
          <>
            <NumberedListItem>{description}</NumberedListItem>

            {list && (
              <>
                <BulletList>
                  {list.map((item) => (
                    <BulletListItem>{item}</BulletListItem>
                  ))}
                </BulletList>
              </>
            )}
          </>
        ))}
      </NumberedList>
    </Section>
  </div>
);

export default TermsDetails;
